import { render, staticRenderFns } from "./ChipPrioridadeFormCarga.vue?vue&type=template&id=690dbe20&"
import script from "./ChipPrioridadeFormCarga.vue?vue&type=script&lang=js&"
export * from "./ChipPrioridadeFormCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports